import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

// Gates the whole Home landing page on the company setting
// `supervisorDashboardEnabled`. While it is off, "/" keeps rendering the flex
// scheduler exactly as before.
const useSupervisorHomeEnabled = (): boolean => {
	return useSelector(
		(state: StoreType) =>
			state.user?.userData?.supervisorDashboardEnabled === true
	);
};

export default useSupervisorHomeEnabled;
